
import '../../App.css';
import './GerenciamentoPage.css';

import Header from '../../components/Header/Header';
import Sidebar from '../../modules/Ui/Sidebar/Sidebar';
import Titulo from '../../modules/Ui/Titulo/Titulo';
import Navbar from '../../modules/Ui/Navbar/Navbar';
import ConteudoDinamico from '../../modules/Ui/ConteudoDinamico/ConteudoDinamico';
import Footer from '../../components/Footer/Footer';

import {
  GerenciamentoProvider,
  useGerenciamento,
} from '../../modules/Context/GerenciamentoContext';

function GerenciamentoLayout() {
  const { selecionarModulo, selecionarAcao } = useGerenciamento();
  const { retorno } = useGerenciamento();
  const { moduloSelecionado } = useGerenciamento();


  const actions = ['novo', 'alterar', 'pesquisar'];

  return (
    <div className="Gerenciamento-container">
      <Header />

      <section>
        <Sidebar onSelect={selecionarModulo} />

        <div className="Gerenciamento-alinhamento">
          <Titulo text="Gerenciamento de" />

          <Navbar
            actions={actions}
            onActionClick={selecionarAcao}
          />

          {retorno && (
            <div className={retorno.tipo === "sucesso" ? "mensagem-sucesso" : "mensagem-erro"}>
              {retorno.mensagem}
            </div>
          )}

          <ConteudoDinamico />
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default function GerenciamentoPage() {
  return (
    <GerenciamentoProvider>
      <GerenciamentoLayout />
    </GerenciamentoProvider>
  );
}
